import {PanelContent} from '@tritt/multipanel'

export const REPORTS_PREFIX = '/reports'

export const allContent: PanelContent[] = []

export const registerRoute = (route: PanelContent) => {
    allContent.push(route)
}